import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DefaultService, PowerSupplyAlertsRequest } from '@psnb/psnb-api';
import { AuthService, PSScrollerUpdatesCodeService } from '@psnb/services';
import { CommonService } from '../../common/common.service';

@Component({
  selector: 'psnb-mobile-power-supply-alerts',
  templateUrl: './power-supply-alerts.component.html',
  styleUrls: ['./power-supply-alerts.component.scss']
})
export class PowerSupplyAlertsComponent implements OnInit {
  showMessage: boolean = false;
  messagescroll: string = '';
  duration: string = '';
  macaddress:any;
  powerSupplyAlertsRequest: PowerSupplyAlertsRequest;
  showProgressBaralert: boolean = false;
  alertResult:any;
  showcount: boolean = false;
  psname:any;
  psid:any;
  nopsid:boolean=false;
  userpermissions:any;
  constructor(
    private psScrollerUpdatesCodeService: PSScrollerUpdatesCodeService,
    private authService: AuthService,
    private psnbApi : DefaultService,
    private route: ActivatedRoute,
    private router:Router
  ) {
    this.powerSupplyAlertsRequest = {};
   }

  ngOnInit() {
    this.userpermissions = JSON.parse(localStorage.getItem('user-permissions'));
    //this.userpermissions = this.authService.getDecryptConfig;
    if (this.userpermissions=='' || !this.authService.isAuthorizedPSNBUser) {
      this.router.navigate(['/unauthorized']);
    }
    for (let element of this.userpermissions) {
    //redirect the url to list page
     if (element.category === CommonService.PSALERTSPAGE && element.functionality === CommonService.PSALERTSPAGEFUNC && element.permission != CommonService.ENABLED) {
      this.router.navigate(['/pageunauthorized']);
      return;
    }
    }
    this.route.queryParams
    .subscribe(params => {
      this.macaddress = params['macAddress'];
      this.psname = params['psname'];
      this.psid = params['powerSupplyId'];
      this.fetchMessageAndDuration();
    });
    if(this.psid !=null || this.psid != undefined){
    this.getAlerts(this.psid);
    } else{
    this.nopsid=true;
    }
  }

  private fetchMessageAndDuration(): void {
    this.psScrollerUpdatesCodeService.fetchActiveScroller().subscribe((data) => {
      if(data.ntId != null){
      this.messagescroll = data.message;
      this.duration = data.duration;
      this.showMessage = true;
      setTimeout(() => {
        this.showMessage = false;
      }, this.parseDuration(this.duration));
    }
    });
  }

  private parseDuration(duration: string): number {
    const [hours, minutes, seconds] = duration.split(':').map(Number);
    return (hours * 60 * 60 + minutes * 60 + seconds) * 1000; // Convert to milliseconds
  }


  getAlerts(psid){
    this.showProgressBaralert = true;
    this.showcount = false;
    this.powerSupplyAlertsRequest.alertClearType = "A";
    this.powerSupplyAlertsRequest.historyReq = false;
    //this.powerSupplyAlertsRequest.infoAlertReq = true;
    //this.powerSupplyAlertsRequest.macAddress = macaddress;
    this.powerSupplyAlertsRequest.powersupplyId = Number(psid);
    this.powerSupplyAlertsRequest.rowLimit = 5000;
    this.powerSupplyAlertsRequest.sortBy = "DESC";
    this.psnbApi.getPowerSupplyAlertsList(this.powerSupplyAlertsRequest).subscribe(result => {
      this.alertResult = this.processData(result);
      this.showcount = true;
      this.showProgressBaralert = false;
    }, err => {
      this.showProgressBaralert = false;
    });
  }

  processData(rowData) {
    rowData.psAlertsList.forEach(element => {
      if (element.deviceName && element.deviceType) {
        element.impactedDevices = element.deviceName.replace(/,/g, ', ') + ' - ' + element.deviceType  + ' (Storm)';
      }else {
        element.impactedDevices = element.psNodes + ' - ' + element.deviceType + ' (PSNB)';
    }
      element.alertStartTime = (element.alertStartTime) ? new Date(element.alertStartTime).toLocaleString() : null;
      element.alertEndTime = (element.alertEndTime) ? new Date(element.alertEndTime).toLocaleString() : null;
      element.psExpectedFailureTime = (element.psExpectedFailureTime) ? new Date(element.psExpectedFailureTime).toLocaleString() : null;

      let alertDuration = null;
      if (element.alertDuration) {
        alertDuration = (element.alertDuration > 1) ? 'Mins' : 'Min';
        alertDuration = element.alertDuration + ' ' + alertDuration;
      } else if ( element.alertEndTime && Math.abs(element.alertEndTime - element.alertStartTime) < 100000) {
        alertDuration = '0 Min';
      }
      element.alertDuration =  alertDuration;

      if (!element.deviceName && element.psNodes) {
        element.impactedDevices = element.psNodes + ' - ' + element.deviceType + ' (PSNB)';
      }
    });
    return rowData;
  }

}
